module.exports = __webpack_public_path__ + "img/popup.a471f32d.jpg";